import axios from '../../utils/axios2'
import queryString from '@/utils/queryString';
export default {

    namespaced: true,

    state: {
        truck: null,
        trucks: []
    },

    mutations: {
        setTruck(state, payload) {
            state.truck = payload;
        },
        setTrucks(state, payload) {
            state.trucks = payload;
        },
        restTrucks(state) {
            state.trucks = [];
        }
    },

    actions: {
        storeTruck({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "post",
                    url: "trucks",
                    data: payload,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.response.data)
                })
            });
        },
        updateTruck({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "put",
                    url: `trucks/${payload.id}`,
                    data: payload.form,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.response.data)
                })
            });
        },
        fetchTruck({commit, rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `trucks/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then((response) => {
                    commit('setTruck', response.data);
                    resolve(response);
                })
                .catch((error) => {
                    reject(error)
                })
            });
        },
        fetchTrucks({commit, rootState}, payload) {
            let query = queryString(payload);
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `trucks?${query}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then((response) => {
                    commit('setTrucks', response.data.data);
                    resolve(response);
                })
                .catch((error) => {
                    reject(error)
                })
            });
        },
        removeTruck({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "delete",
                    url: `trucks/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error.response.data)
                })
            });
        },
        restTrucks({commit}) {
            commit('restTrucks');
        },
        fetchTrucksWithTrackableDistance({rootState}, payload) {
            return new Promise((resolve, reject) => {
                axios.request({
                    method: "get",
                    url: `trucks-distance-trackable/${payload}`,
                    headers: {Authorization: `Bearer ${rootState.authentication.api_token}`}
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error);
                })
            });
        }

    }

}